import { HttpClient } from '@angular/common/http';
import { SetPackEnvProvider } from './set-pack-env.provider';
import {
  TSetPackTransactionListingRequest,
  TSetPackTransactionListingResponse,
  TSetPackDashboardCountResponse,
  TSetPackListingRequest,
  TSetPackListingResponse,
  TSetPackByIdRequest,
  TSetPackByIdResponse,
  TSetPackAuditLogResponse,
  TSetPackEditPackCountRequest,
  TSetPackCreateRequest,
  TSetPackByCreateResponse,
  TSetPackValidateRequest,
  TSetPackValidateResponse,
  TTotalWipRequest,
  TGetBctxListWithDestinationRequest,
  TGetBctxListWithDestinationResponse,
  TSetPackAuditLogRequest,
  TSetPackDashboardCountRequest,
  TSetPackEditPackCountResponse,
} from '@monorepo/types';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SetPackDataProvider {
  constructor(private http: HttpClient, private setPackEnvProvider: SetPackEnvProvider) {}

  getSetPackDashboardCount(request: TSetPackDashboardCountRequest) {
    return this.http.post<TSetPackDashboardCountResponse>(
      this.setPackEnvProvider.getEnvVar('GET_SET_PACK_DASHBOARD_COUNT'),
      request,
    );
  }

  loadSetPackTransactionListing(request: TSetPackTransactionListingRequest) {
    return this.http.post<TSetPackTransactionListingResponse>(
      this.setPackEnvProvider.getEnvVar('GET_SET_PACK_TRANSACTIONS'),
      request,
    );
  }

  getSetPackListing(request: TSetPackListingRequest) {
    return this.http.post<TSetPackListingResponse>(this.setPackEnvProvider.getEnvVar('GET_SET_PACK_LISTING'), request);
  }

  getSetPackById(request: TSetPackByIdRequest) {
    return this.http.post<TSetPackByIdResponse>(this.setPackEnvProvider.getEnvVar('FERCH_PACK_BY_ID'), request);
  }

  getAuditLogs(request: TSetPackAuditLogRequest) {
    return this.http.post<TSetPackAuditLogResponse>(
      `${this.setPackEnvProvider.getEnvVar('GET_PACK_AUDIT_LOGS')}`,
      request,
    );
  }

  editPackCount(request: TSetPackEditPackCountRequest) {
    return this.http.post<TSetPackEditPackCountResponse>(
      this.setPackEnvProvider.getEnvVar('SET_PACK_EDIT_PACK_COUNT'),
      request,
    );
  }

  createSetPack(request: TSetPackCreateRequest) {
    return this.http.post<TSetPackByCreateResponse>(this.setPackEnvProvider.getEnvVar('CREATE_SET_PACK'), request);
  }

  validateSetPack(request: TSetPackValidateRequest) {
    return this.http.post<TSetPackValidateResponse>(this.setPackEnvProvider.getEnvVar('VALIDATE_SET_PACK'), request);
  }

  getTotalWipQuantity(request: TTotalWipRequest) {
    return this.http.post<number>(this.setPackEnvProvider.getEnvVar('GET_TOTAL_WIP_QTY'), request);
  }

  getBctxListWithDestination(request: TGetBctxListWithDestinationRequest, factoryId: string) {
    return this.http.post<TGetBctxListWithDestinationResponse>(
      this.setPackEnvProvider.getEnvVar('GET_BCTX_LIST_WITH_DESTINATION') + factoryId,
      request,
    );
  }
}
